export enum InviteType {
  COAPPLICANT = 'co-applicant',
  RENTER = 'renter',
  GUARANTOR = 'guarantor',
}
